<script>
// import fullcalendar from 'vue-fullcalendar'
import MovementShiftComponent from '@/components/MovementShiftComponent'
import MainLayout from '@/router/layouts/mainLayout'
import {StringUtil} from '@/utils/StringUtil'
import moment from 'moment'
export default {
  created () {
    let dateStr = this.$route.query.currentDate
    if (StringUtil.isEmpty(dateStr)) {
      this.currentDate = moment().startOf('month')
      dateStr = this.currentDate.format('YYYYMM')
    } else {
      this.currentDate = moment(dateStr, 'YYYYMM').startOf('month')
    }
    // 清除event和routeName的sesison 便于便详细里重新请求。
    if (sessionStorage.getItem('shiftEventInfo')) {
      sessionStorage.removeItem('shiftEventInfo')
    }
    if (sessionStorage.getItem('routeName')) {
      sessionStorage.removeItem('routeName')
    }

    this.getData(dateStr)
    // this.getAllStationData()
  },
  data () {
    return {
      shiftInfoList: [],
      events: [],
      currentDate: null,
      loading: false
    }
  },
  components: {
    MovementShiftComponent,
    MainLayout
  },
  methods: {
    changeMonth (start, end, newDate) {
      this.currentDate = newDate
      this.getData(newDate.format('YYYYMM'))
    },
    getData (dateStr) {
      this.loading = true
      this.$axios.get('shift/queryShiftInfoList', {params: {date: dateStr}}).then(response => {
        if (response.data.date === this.currentDate.format('YYYYMM')) {
          let shiftInfoList = response.data.shiftInfoList
          let events = []
          for (let shiftInfo of shiftInfoList) {
          // 判断是否未公开
            let isOpen = true
            if (!shiftInfo.businessStatus || shiftInfo.businessStatus === 1) {
              if (shiftInfo.openFlag === 0) {
                isOpen = false
              }
            }
            events.push({
              title: shiftInfo.title,
              start: shiftInfo.moveShiftTime.substring(0, 4) + '-' + shiftInfo.moveShiftTime.substring(4, 6) + '-' + shiftInfo.moveShiftTime.substring(6, 8),
              isWarning: shiftInfo.isWarning,
              isOpen: isOpen
            })
          }
          this.events = events
          this.shiftInfoList = shiftInfoList
        }
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    }
    // 获取所有停留点的详细信息
    // getAllStationData () {
    //   this.$axios.get('route/getAllStationData').then(res => {
    //     // 直接塞进session 方便子页面 接送值
    //     sessionStorage.setItem('stationDataList', JSON.stringify(res.data.stationDataList))
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // }
  }
}
</script>

<template>
  <MainLayout>
      <movement-shift-component
      :events="events"
      :shiftInfoList="shiftInfoList"
      :loading=loading
      @changeMonth="changeMonth"
      style="width:99%;height:calc(100% - 100px);display: flex;flex-direction: column;"></movement-shift-component>
  </MainLayout>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/router/views/MovementShift.vue